import { errorToastClassName, appToast as toast } from "@/components/ui/baseUi/sonner"
import { useCurrentBox } from "@modules/box/hooks/useBox"
import { useServicesContext } from "@modules/core/services/services.context"
import { word } from "@modules/core/utils/i18n"
import { useMutation } from "@tanstack/react-query"

type DownloadTransactionPdfParams = {
  transactionId?: string
  invoiceId?: string
  invoiceNumber: string
}

export const useTransactionPdfDownload = () => {
  const { userFinanceApi, boxFinanceApi } = useServicesContext()
  const { result: boxId } = useCurrentBox()

  const financeApi = boxId ? boxFinanceApi : userFinanceApi

  const { mutateAsync: downloadTransactionPdf, isPending } = useMutation({
    mutationFn: async ({ transactionId, invoiceId, invoiceNumber }: DownloadTransactionPdfParams) => {
      let blob: Blob

      if (invoiceId) {
        blob = await boxFinanceApi.getOutofBandTransactionPdf(invoiceId)
      } else if (transactionId) {
        blob = await financeApi.getTransactionPdf(transactionId)
      } else {
        throw new Error("Either transactionId or invoiceId must be provided")
      }

      const url = window.URL.createObjectURL(blob)
      const link = document.createElement("a")
      link.href = url
      link.download = `${invoiceNumber}.pdf`
      document.body.appendChild(link)
      link.click()

      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)

      return transactionId || invoiceId
    },
    onError: () => {
      toast.error(word("global.error.label"), {
        classNames: errorToastClassName(),
      })
    },
  })

  return {
    downloadTransactionPdf,
    isDownloading: isPending,
  }
}
